import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  "xml:space": "preserve",
  baseProfile: "full",
  viewBox: "0 0 76 76"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M20 17h23.25L56 29.75V40l-4-2.5V34H39V21H24v34h12l-4 4H20zm23 5.25V30h7.75zM48 38c5.523 0 10 4.477 10 10s-4.477 10-10 10a9.95 9.95 0 0 1-5.08-1.385l-6.799 6.8a2 2 0 0 1-2.828 0l-.707-.708a2 2 0 0 1 0-2.828l6.799-6.8A9.95 9.95 0 0 1 38 48c0-5.523 4.477-10 10-10m0 4a6 6 0 1 0 0 12 6 6 0 0 0 0-12"
    }, null, -1)
  ])))
}
export default { render: render }